import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { StairsIcon, FuelIcon, WrenchIcon, ClockIcon } from './Icons';
export function ProblemSection() {
  const {
    t
  } = useLanguage();
  const icons = [<StairsIcon className="w-6 h-6" data-id="element-817" />, <FuelIcon className="w-6 h-6" data-id="element-818" />, <WrenchIcon className="w-6 h-6" data-id="element-819" />, <ClockIcon className="w-6 h-6" data-id="element-820" />];
  return <section className="py-24 bg-brand-black relative border-b border-white/5" data-id="element-821">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-822">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-823">
          <h2 className="font-oswald text-4xl md:text-5xl font-bold text-white mb-6 uppercase" data-id="element-824">
            {t.problem.title}
          </h2>
          <p className="text-xl text-gray-400" data-id="element-825">{t.problem.subtitle}</p>
        </motion.div>

        {/* Split layout: pain points + photo */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-16 items-center" data-id="element-826">
          {/* Pain points */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-827">
            {t.problem.points.map((point: string, index: number) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-white/5 p-6 rounded-lg border border-brand-red/20 hover:border-brand-red/50 transition-colors" data-id="element-828">
                <div className="flex-shrink-0 text-brand-red mt-1" data-id="element-829">
                  {icons[index]}
                </div>
                <p className="text-lg text-gray-200 font-medium" data-id="element-830">{point}</p>
              </motion.div>)}
          </div>

          {/* Photo */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative rounded-2xl overflow-hidden hidden lg:block" data-id="element-831">
            <img src="https://cdn.magicpatterns.com/uploads/7snMZpQw5zWLcQqkYahQAR/hf_20260430_172859_f7f406e6-7df9-4aa0-94ad-0bd5e5211fe2.png" alt="Move Fighters team carefully packing items inside a home" className="w-full h-full object-cover rounded-2xl aspect-[4/3]" data-id="element-832" />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-black/40 to-transparent rounded-2xl" data-id="element-833" />
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="bg-brand-red/10 border border-brand-red p-8 rounded-xl text-center" data-id="element-834">
          <p className="font-oswald text-2xl md:text-3xl text-brand-red mb-4 uppercase font-bold" data-id="element-835">
            {t.problem.conclusion}
          </p>
          <p className="text-lg text-white" data-id="element-836">{t.problem.extinguish}</p>
        </motion.div>
      </div>
    </section>;
}